import { render, staticRenderFns } from "./LocoBadge.vue?vue&type=template&id=c6a50134"
import script from "./LocoBadge.vue?vue&type=script&lang=js"
export * from "./LocoBadge.vue?vue&type=script&lang=js"
import style0 from "./LocoBadge.vue?vue&type=style&index=0&id=c6a50134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports